<div class="container">
  <ul class="breadcrumb">
    <li><strong style="color: #505050;">Onde estou:</strong></li>
    <li class="active">
      <span>Financeiro/<b>Dashboard Frota</b></span>
    </li>
  </ul>
   <h1 class="dashboard__titulo">DASHBOARD FROTA</h1>

  <div class="row dashboard__heading">
    <div class="col-12 dashboard__heading-row">

      <button
        type="button"
        class="dashboard__nav-btn dashboard__nav-btn--ativo"
        aria-current="page"
         (click)="voltarHome()"
      >
        PREÇOS NOS POSTOS
      </button>
    </div>
  </div>

  <div class="dashboard__shell">
    <div *ngIf="loading" class="dashboard__loading" role="status" aria-live="polite">
      <div class="spinner-border" aria-hidden="true">
        <span class="visually-hidden">Carregando...</span>
      </div>
      <h2 class="dashboard__loading-text">Carregando indicadores...</h2>
    </div>

    <div *ngIf="!loading && data" class="row g-4">
      <div class="col-12 col-md-6 col-lg-3">
        <app-dashboard-card title="Alertas de Preço" [value]="totalAlertasPrecoBomba"
          subtitle="Postos com tendência de variação" icon="warning" iconVariant="amber" valueTone="default"
          subtitleTone="muted"></app-dashboard-card>
      </div>
      <div class="col-12 col-md-6 col-lg-3">
        <app-dashboard-card title="Preços que Subiram" [value]="totalSubiram" subtitle="Em alta nos últimos 30 dias"
          icon="trending_up" iconVariant="danger" valueTone="default" subtitleTone="muted"></app-dashboard-card>
      </div>
      <div class="col-12 col-md-6 col-lg-3">
        <app-dashboard-card title="Preços que Desceram" [value]="totalDesceram" subtitle="Em queda nos últimos 30 dias"
          icon="trending_down" iconVariant="success" valueTone="success" subtitleTone="muted"></app-dashboard-card>
      </div>
      <div class="col-12 col-md-6 col-lg-3">
        <app-dashboard-card title="Economia Potencial" [value]="'R$ ' + (economiaPotencial | number: '1.2-2')"
          subtitle="Aplicando desvios sugeridos" icon="savings" iconVariant="success" valueTone="success"
          subtitleTone="muted" [destaque]="true"></app-dashboard-card>
      </div>

      <!-- Teste git -->

      <div class="col-12">
        <div class="alertas__header">
          <h3 class="alertas__titulo">
            <span class="material-icons alertas__titulo-icon" aria-hidden="true">notifications_active</span>
            <span>Alertas de Preço</span>
            <span class="alertas__contagem" *ngIf="totalAlertas > 0">
              ({{ totalFiltrados }} de {{ totalAlertas }})
            </span>
          </h3>

          <div class="alertas__chips" role="group" aria-label="Filtrar alertas por direção">
            <button type="button" class="alertas__chip" [class.alertas__chip--ativo]="filtroDirecao === 'todos'"
              (click)="selecionarFiltroDirecao('todos')" [attr.aria-pressed]="filtroDirecao === 'todos'">
              <span>Todos</span>
              <span class="alertas__chip-num">{{ totalAlertas }}</span>
            </button>
            <button type="button" class="alertas__chip alertas__chip--subiu"
              [class.alertas__chip--ativo]="filtroDirecao === 'subiu'" (click)="selecionarFiltroDirecao('subiu')"
              [attr.aria-pressed]="filtroDirecao === 'subiu'">
              <span class="material-icons alertas__chip-icon" aria-hidden="true">trending_up</span>
              <span>Subiram</span>
              <span class="alertas__chip-num">{{ totalSubiram }}</span>
            </button>
            <button type="button" class="alertas__chip alertas__chip--desceu"
              [class.alertas__chip--ativo]="filtroDirecao === 'desceu'" (click)="selecionarFiltroDirecao('desceu')"
              [attr.aria-pressed]="filtroDirecao === 'desceu'">
              <span class="material-icons alertas__chip-icon" aria-hidden="true">trending_down</span>
              <span>Desceram</span>
              <span class="alertas__chip-num">{{ totalDesceram }}</span>
            </button>
          </div>

          <div class="busca" role="search">
            <span class="material-icons busca__icon" aria-hidden="true">search</span>
            <input type="search" class="busca__input" name="termoBusca" [(ngModel)]="termoBusca"
              (ngModelChange)="onBuscaChange()" placeholder="Buscar por posto, código ou endereço..."
              aria-label="Buscar alertas por posto, código ou endereço" />
            <button *ngIf="termoBusca" type="button" class="busca__limpar" (click)="termoBusca = ''; onBuscaChange()"
              aria-label="Limpar busca">
              <span class="material-icons" aria-hidden="true">close</span>
            </button>
          </div>
        </div>

        <div class="alertas__lista vstack gap-3" *ngIf="totalFiltrados > 0">
          <app-preco-alerta-card
            *ngFor="
              let alerta of (alertasFiltrados | paginate: { id: idPaginacao, itemsPerPage: itensPorPagina, currentPage: paginaAtual });
              trackBy: trackByChave
            "
            [alerta]="alerta"
          ></app-preco-alerta-card>
        </div>

        <div class="alertas__vazio" *ngIf="mostrarEmptySemDados">
          <span class="material-icons alertas__vazio-icon" aria-hidden="true">inbox</span>
          <p class="alertas__vazio-texto">Nenhum alerta na rede no momento.</p>
        </div>

        <div class="alertas__vazio" *ngIf="mostrarEmptyFiltro">
          <span class="material-icons alertas__vazio-icon" aria-hidden="true">search_off</span>
          <p class="alertas__vazio-texto">
            Nenhum alerta encontrado para os filtros aplicados.
          </p>
          <button type="button" class="alertas__vazio-btn btn btn-primary" (click)="limparFiltros()">
            Limpar filtros
          </button>
        </div>

        <div class="alertas__paginacao" *ngIf="mostrarPaginacao">
          <pagination-controls [id]="idPaginacao" previousLabel="Anterior" nextLabel="Próxima" [responsive]="true"
            (pageChange)="paginaAtual = $event"></pagination-controls>
        </div>
      </div>
    </div>
  </div>
</div>